import './ConfirmationModal.scss';
import { TranslationKey, useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, ReactNode } from 'react';
import { ButtonWithLoader } from '../../design/buttons/ButtonWithLoader';
import { S_Modal } from '../../design/modals/modal/S_Modal';
import { IOverlayLoaderStore } from '../../modules/common/OverlayLoader.store';

interface IProps {
  confirmationDescription?: TranslationKey | ReactElement;
  confirmationQuestion?: TranslationKey | ReactElement;
  confirmationQuestionValues?: Record<string, string | number>;
  confirmationHeader: TranslationKey;
  confirmationYes?: TranslationKey;
  confirmationNo?: TranslationKey;
  showModal: boolean;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
  loaderKey?: string;
  children?: ReactNode;
}

export const ConfirmationModal = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const loaderStore = useInjection(IOverlayLoaderStore.$);

  const handleConfirm = (): void => {
    void props.onConfirm();
  };

  return (
    <S_Modal
      className='confirmation-dialog'
      isOpen={props.showModal}
      toggle={props.onCancel}
      headerText={t(props.confirmationHeader)}
      buttons={
        <>
          <Button
            variant='outlined'
            color={'neutral'}
            onClick={props.onCancel}
            disabled={props.loaderKey ? loaderStore.isSpinnerVisible(props.loaderKey) : false}
          >
            {t(props.confirmationNo || 'cancel')}
          </Button>
          <ButtonWithLoader
            onClick={handleConfirm}
            loaderKey={props.loaderKey}
          >
            {t(props.confirmationYes || 'yes')}
          </ButtonWithLoader>
        </>
      }
    >
      <div className='confirmation-content'>
        {props.confirmationDescription &&
          (typeof props.confirmationDescription === 'string' ? <div>{t(props.confirmationDescription)}</div> : <div>{props.confirmationDescription}</div>)}
        {props.confirmationQuestion && (
          <div>
            <>{typeof props.confirmationQuestion === 'string' ? t(props.confirmationQuestion, props.confirmationQuestionValues) : props.confirmationQuestion}</>
          </div>
        )}
        {props.children && <div>{props.children}</div>}
      </div>
    </S_Modal>
  );
});
